/* @flow */
import idx from 'idx';
import gql from 'graphql-tag';
import * as React from 'react';
import { graphql } from 'react-apollo';

type Props = {
  data: *,
  children: Function,
  organizationUUID: string,
};

class OrganizationIntegrationPermissions extends React.Component<Props, {}> {
  render() {
    return this.props.children({
      loading: this.props.data.loading,
      canSee: idx(
        this.props,
        _ => _.data.organizations[0].permissions.adminConsole.seeConnectedAccountsTab
      ),
      canEdit: idx(
        this.props,
        _ => _.data.organizations[0].permissions.canEditOrganizationIntegrationSettings
      ),
    });
  }
}

const withPermission = graphql(
  gql`
    query AdminIntegratedToolsView($organizationUUID: String!) {
      organizations(uuids: [$organizationUUID]) {
        uuid
        type
        permissions {
          canEditOrganizationIntegrationSettings
          adminConsole {
            seeConnectedAccountsTab
          }
        }
      }
    }
  `,
  {
    options: ({ organizationUUID }) => ({
      variables: { organizationUUID },
    }),
  }
);

export default withPermission(OrganizationIntegrationPermissions);
